import React from "react";
import Box from "@mui/material/Box";

const ArticleError = ({ isNotPublic, navigate }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundColor: "#F9FAFA",
        gap: "16px",
      }}
    >
      <Box
        sx={{
          fontSize: "24px",
          fontWeight: 600,
          color: "#061522",
          fontFamily: "Inter",
        }}
      >
        {isNotPublic ? "Article Not Available" : "Article Not Found"}
      </Box>
      <Box
        sx={{
          fontSize: "16px",
          color: "#405261",
          fontFamily: "Inter",
        }}
      >
        {isNotPublic
          ? "This article is not publicly available."
          : "The article you are looking for does not exist."}
      </Box>
      <Box
        onClick={() => navigate(-1)}
        sx={{
          padding: "10px 24px",
          backgroundColor: "#148DFD",
          color: "#fff",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 500,
          fontFamily: "Inter",
          "&:hover": {
            backgroundColor: "#1178D4",
          },
        }}
      >
        Go Back
      </Box>
    </Box>
  );
};

export default ArticleError;
